module.exports = __webpack_public_path__ + "img/Slide3.e9c2e123.jpg";